<template>
  <textarea type="text" class="form-control" :class="{'is-invalid': layoutData.errorText != null}" v-model="valueData" @change="onChange"></textarea>
</template>

<script>
  export default {
    name: "timesheet-field-textarea",
    props: {
      layout: {
        type: Object,
        required: true
      },
      value: {
        default: null
      },
      index: {
        type: Number,
        required: false
      }
    },
    data() {
      return {
        layoutData: this.layout,
        valueData: this.value
      }
    },
    watch: {
      value(newval) {
        this.valueData = newval;
      }
    },
    computed: {
      fieldType() {
        return this.layoutData.type
      },
      fieldLabel() {
        return this.layoutData.label
      },
    },
    methods: {
      onChange(e) {
        this.$emit("change", e, this.layoutData, this.valueData, this.index);
      }
    },
  }
</script>

<style lang="scss" scoped>

</style>